import {
  AppleImage,
  EarPhoneImage,
  GoogleImage,
  HeadPhoneImage,
  FidgetImage,
  IOSImage,
  MiniBotImage,
  MosquitoImage
 } from '../image';

export const newProductDetails = [
  {
    name: 'Earphone',
    image: EarPhoneImage
  },
  {
    name: 'Google',
    image: GoogleImage
  },
  {
    name: 'Minibot',
    image: MiniBotImage
  },
  {
    name: 'Headphone',
    image: HeadPhoneImage
  },
  {
    name: 'Mouse',
    image: AppleImage
  },
  {
    name: 'Fidget',
    image: FidgetImage
  },
  {
    name: 'Mobile',
    image: IOSImage
  },
  {
    name: 'Mosquito',
    image: MosquitoImage
  },
]